/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowreviewbasics3Inputs */

const en_aiflowreviewbasics3 = /** @type {(inputs: Aiflowreviewbasics3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When and where`)
};

const de_aiflowreviewbasics3 = /** @type {(inputs: Aiflowreviewbasics3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann und wo`)
};

/**
* | output |
* | --- |
* | "When and where" |
*
* @param {Aiflowreviewbasics3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowreviewbasics3 = /** @type {((inputs?: Aiflowreviewbasics3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowreviewbasics3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowreviewbasics3(inputs)
	return de_aiflowreviewbasics3(inputs)
});
export { aiflowreviewbasics3 as "aiFlowReviewBasics" }